import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import {
  createMigrate,
  createTransform,
  PersistConfig,
  persistReducer,
  persistStore,
} from "redux-persist";
import storage from "redux-persist/es/storage";
import { setupListeners } from "@reduxjs/toolkit/query/react"; // Correct import path
import rootReducer, { AppState } from "../reducer/rootReducer";
import axiosInstance from "../../api/agent";
import dateRangeReducer from "../reducer/features/Date/dateRangeSlice";

// Transform function for credentials (example)
const TransformCredentials = createTransform(
  (inboundState: any, key): any => {
    // Apply inbound transformation logic
    return { ...inboundState };
  },
  (outboundState: any, key) => {
    // Apply outbound transformation logic
    return { ...outboundState };
  },
  {} // additional configuration if needed
);

// Migration configuration
const MIGRATION_DEBUG = true;
const migrations = {
  4: (state: any) => ({
    ...state._persist,
  }),
  6: (state: any) => ({
    ...state._persist,
  }),
};

// Custom store middleware (currently no functionality)
export function storeMiddleware(store: any) {
  return (next: any) => (action: any) => {
    switch (action.type) {
      // You can add more actions here if needed
      default:
        break;
    }

    return next(action);
  };
}

// Persist configuration
const persistConfig: PersistConfig<any, any, any, any> = {
  key: "root",
  storage: storage,
  whitelist: ["authReducer", "JobReducer", "dateRangeReducer"],
  version: 7,
  migrate: createMigrate(migrations, { debug: MIGRATION_DEBUG }),
  transforms: [TransformCredentials], // Apply credential transformations
};

// Persisted reducer
const persistedReducer = persistReducer<any>(persistConfig, rootReducer);

// Store configuration with middleware
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(storeMiddleware); // Adding custom middleware if needed
  },
});

// Set up listeners for RTK Query (ensures proper cache invalidation)
setupListeners(store.dispatch);

// Define types for Thunk actions
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>;

// Axios instance with authorization headers
export const getAxiosInstance = () => {
  // Add a request interceptor
  axiosInstance.defaults.headers.common["Authorization"] =
    "Bearer " + store.getState()?.authReducer?.token;
  return axiosInstance;
};

// Persist store setup
export const persistor = persistStore(store, null, () => {});

export default store;
